import { CropAPI } from '@/api'

export default {
  namespaced: true,
  state: {
    data: [],
    loaded: false,
  },
  mutations: {
    saveData(state, data) {
      state.data = data;
    },
    load(state) {
      state.loaded = true;
    }
  },
  actions: {
    updateData({ commit }) {
      return CropAPI.getUserCrops().then(res => {
        commit('saveData', res.data);
        commit('load');
      });
    }
  },
  getters: {
    data(state) {
      return state.data;
    },
    isLoaded(state) {
      return state.loaded;
    },
  }
}
